import React, { useEffect, useRef, useState } from "react";
import Webcam from "react-webcam";
import { ReactComponent as CloseIcon } from "../../Assets/icon/close.svg";
import { ReactComponent as Camera } from "../../Assets/icon/camera-01.svg";

const dataURLToFile = (dataURL, filename) => {
  const arr = dataURL.split(",");
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) u8arr[n] = bstr.charCodeAt(n);
  return new File([u8arr], filename, { type: mime });
};

export default function CameraCaptureModal({ isOpen, onClose, onCapture, loading = false }) {
  const webcamRef = useRef(null);
  const [cameraError, setCameraError] = useState("");

  useEffect(() => {
    if (!isOpen) return;
    // Quick capability and context checks (iOS Safari requires HTTPS or localhost)
    const isSecure = typeof window !== 'undefined' && window.isSecureContext;
    const hasMedia = typeof navigator !== 'undefined' && !!navigator.mediaDevices && !!navigator.mediaDevices.getUserMedia;
    if (!isSecure) {
      setCameraError("Camera access requires a secure connection (https or localhost). Open this page over https to use the camera.");
      return;
    }
    if (!hasMedia) {
      setCameraError("Camera is not available in this browser.");
      return;
    }
    // Try requesting a lightweight permission check once opened
    navigator.mediaDevices.getUserMedia({ video: { facingMode: "user" }, audio: false })
      .then(stream => {
        // Immediately stop tracks; react-webcam will request again
        stream.getTracks().forEach(t => t.stop());
        setCameraError("");
      })
      .catch(err => {
        setCameraError(err?.message || "Unable to access the camera. Please check permissions.");
      });
  }, [isOpen]);

  if (!isOpen) return null;

  const handleCapture = async () => {
    if (!webcamRef.current) return;
    const captured = webcamRef.current.getScreenshot();
    if (!captured) return;
    const file = dataURLToFile(captured, "profile_photo.jpg");
    if (onCapture) await onCapture(file);
  };

  return (
    <div className="camera-modal-overlay">
      <div className="camera-modal">
        <button onClick={onClose} className="close-camera-button">
          <CloseIcon />
        </button>
        <p />
        {!cameraError && (
          <Webcam
            audio={false}
            ref={webcamRef}
            screenshotFormat="image/jpeg"
            className="webcam"
            videoConstraints={{ width: 1280, height: 720, facingMode: "user" }}
            mirrored
            playsInline
          />
        )}
        {cameraError && (
          <div className="camera-suggestion" style={{ color: '#D92D20' }}>
            {cameraError}
          </div>
        )}
        <p className="camera-suggestion">
          Let’s capture the real you—smiles welcome
        </p>
        <button onClick={handleCapture} className="capture-button" disabled={loading}>
          <Camera />
          {loading ? "Uploading..." : "Take a photo"}
        </button>
      </div>
    </div>
  );
}
